export default __webpack_public_path__ + "media/images/ad_landing_page/Deloitte-98f063587c628e013202c032cd1cdc29.png";